module.exports = __webpack_public_path__ + "img/intro_1.4a2f7dee.png";